import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../context/AuthContext';
import styles from './Auth.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const LoginForm = ({ onSwitchToRegister, onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // Add this state
  
  const [resetMessage, setResetMessage] = useState('');
  const [loginError, setLoginError] = useState('');
  const { login, loading, resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    setResetMessage('');
    
    const result = await login(email, password);
    console.log('Login result:', result);
    if (result.success) {
      onLoginSuccess();
    } else {
      setLoginError(result.error || 'Login failed.');
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setLoginError('Please enter your email address first.');
      return;
    }
    setLoginError('');
    setResetMessage('Sending reset link...');

    const result = await resetPassword(email);
    if (result.success) {
      setResetMessage('Password reset email sent! Check your inbox.');
    } else {
      setLoginError(result.error);
      setResetMessage('');
    }
  };
  
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  return (
    <div className={styles.formSection}>
      <h2>Welcome Back!</h2>
      <p>Please sign in to access your tools.</p>
      <form onSubmit={handleSubmit} className={styles.authForm}>
        <div className={`form-group ${styles.stackingGroup}`}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
            autoComplete="email" 
          />
        </div>
        <div className={`form-group ${styles.stackingGroup}`}>
          <div className={styles.labelWithLink}>
            <label htmlFor="password">Password</label>
            <span onClick={handleForgotPassword} className={styles.forgotPasswordLink}>
              Forgot Password?
            </span>
          </div>
          <div className={styles.passwordInputContainer}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              className={styles.passwordInput}
              autoComplete="current-password" 
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className={styles.passwordToggle}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
        </div>

        {loginError && <div className={styles.error}>{loginError}</div>}
        {resetMessage && <div className={styles.successMessage}>{resetMessage}</div>}

        <button type="submit" className={styles.submitButton} disabled={loading}>
          {loading ? 'Logging In...' : 'Login'}
        </button>
      </form>
      <p className={styles.switchForm}>
        Don&apos;t have an account? <span onClick={onSwitchToRegister}>SignUp here</span>
      </p>
    </div>
  );
};

LoginForm.propTypes = {
  onSwitchToRegister: PropTypes.func.isRequired,
  onLoginSuccess: PropTypes.func.isRequired,
};

export default LoginForm;